import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();
/**
 * Variant Definitions
 */
const StyledOverviewVariants = {
  mini: css`
    width: 100%;
  `,
  expanded: css`
    ${({ theme }) =>
      isOmp
        ? css`
            border: 1px solid ${theme.COLORS.NEUTRAL_110};
          `
        : css`
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
          `}
    width: 853px;
    margin-right: 18px;
    background-color: ${({ theme }) => theme.COLORS.BASE};
  `
};

const StyledNegotiationVariants = {
  mini: css`
    border-bottom: 3px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    margin-bottom: 20px;
  `,
  expanded: css`
    border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  `
};

const StyledOverviewWrapperVariants = {
  mini: css`
    flex-direction: column;
  `,
  expanded: css`
    flex-direction: row;
  `
};

/**
 * Styled Components
 */
const StyledOverview = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledOverviewVariants.mini,
      expanded: StyledOverviewVariants.expanded
    })}
`;

export const StyledOverviewWrapper = styled.div`
  display: flex;
  padding-bottom: ${({ isSelling }) => (!isSelling ? 37 : 0)}px;
  ${({ isSelling, theme }) =>
    isSelling
      ? applyResponsiveVdpStyles(theme, {
          mini: StyledOverviewWrapperVariants.mini,
          expanded: StyledOverviewWrapperVariants.expanded
        })
      : `flex-direction: column`}
`;

export const StyledOverviewFooter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 36px;
  height: 100%;
  min-height: 72px;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledNegotiationVariants.mini,
      expanded: StyledNegotiationVariants.expanded
    })}
`;

const StyleButton = `
    margin-right: 18px;
    padding: 8px 40px;
`;

export const StyledPrimaryButton = styled(Button.Primary)`
  ${StyleButton}
`;

export const StyledSecondaryButton = styled(Button.Secondary)`
  ${StyleButton}
`;

export default StyledOverview;
